"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgBackground = void 0;

var _styledComponents = require("styled-components");
/**
 * Module dependencies.
 */

/**
 * Export `svgBackground`.
 */


var svgBackground = function svgBackground(svg) {
  return (0, _styledComponents.css)(["background-image:url('data:image/svg+xml;utf8,", "');"], encodeURIComponent(svg));
};

exports.svgBackground = svgBackground;